import type { ScrollStrategy } from '@angular/cdk/overlay';

/** Ported from Clarity `apps/web/src/shared/ui/SidePanel.tsx` (commit `f9217bb5a`). */
/**
 * Brain `SidePanel`'s body-lock counter (`SidePanel.tsx:16-39`) over one CDK block strategy: the page
 * behind stays locked until the **last** stacked panel closes.
 *
 * A CDK `BlockScrollStrategy` per panel cannot do that on its own. It refuses to engage while the
 * global `cdk-global-scrollblock` class is already set, so the second of two stacked panels never
 * holds the lock, and the first one's close releases it while the second is still open — the exact
 * leak brain's counter was written to close. Every stacked panel's overlay gets a strategy from here
 * instead; exclusive panels keep their own block strategy, unchanged.
 */
export class ClarityStackedScrollLock {
	private readonly block: ScrollStrategy;

	private holders = 0;

	constructor(block: ScrollStrategy) {
		this.block = block;
	}

	/** A strategy for one stacked panel's overlay; it holds the lock between its enable and its disable. */
	public strategy(): ScrollStrategy {
		let held = false;

		return {
			attach: (): void => undefined,
			enable: (): void => {
				if (held) {
					return;
				}
				held = true;
				this.acquire();
			},
			disable: (): void => {
				if (!held) {
					return;
				}
				held = false;
				this.release();
			},
		};
	}

	private acquire(): void {
		this.holders += 1;
		if (this.holders === 1) {
			this.block.enable();
		}
	}

	private release(): void {
		this.holders -= 1;
		if (this.holders === 0) {
			this.block.disable();
		}
	}
}
